import Button from '@/components/Button';
import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import ProductListTable from '@/modules/product/components/ProductListTable';
import { ProductListAddPath } from '@/modules/product/paths';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import { RectangleStackIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/24/solid';

const ProductListList = () => {
  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();

  return (
    <>
      <SettingsHeader title="Product Lists" icon={<RectangleStackIcon className="w-6 h-6" />}>
        <Button
          to={ProductListAddPath}
          icon={<PlusIcon className="h-5 w-5 mr-1" />}
          variant="secondary"
        >
          Add Product List
        </Button>
      </SettingsHeader>

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <ProductListTable searchQuery={searchQuery} page={page} onChangePage={handlePageChange} />
    </>
  );
};

export default ProductListList;
